import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { Link } from 'react-router-dom';

const phrases = ["quantum-resistant", "environmentally conscious", "decentralized"];

function App() {
  const [text, setText] = useState('');
  const [index, setIndex] = useState(0);
  const typingTimeout = useRef(null);

  useEffect(() => {
    const targetPhrase = phrases[index];

    if (text === targetPhrase) {
      typingTimeout.current = setTimeout(() => setText(t => t.slice(0, -1)), 2000);
    } else if (text.length < targetPhrase.length) {
      typingTimeout.current = setTimeout(() => setText(targetPhrase.slice(0, text.length + 1)), 200);
    }

    return () => clearTimeout(typingTimeout.current);
  }, [text, index]);

  useEffect(() => {
    if (text.length === 0) {
      setIndex((index + 1) % phrases.length);
    }
  }, [text,index]);

  return (
    <div className="App">
      <header className="App-header">
        <div className="terminal-window">
          <div className="terminal-header">
            <span className="terminal-title">C12://ABOUT</span>
            <div className="terminal-controls">
              <span className="terminal-control">_</span>
              <span className="terminal-control">□</span>
              <span className="terminal-control">×</span>
            </div>
          </div>
          <div className="terminal-content">
            <p className="terminal-line">
              <span className="terminal-prompt">$</span> C12 is a core contributor to the{" "}
              <a href="https://supernovanetwork.xyz/" className="terminal-link" target="_blank" rel="noopener noreferrer">
                Supernova blockchain
              </a>
              .
            </p>
            
            <p className="terminal-line">
              <span className="terminal-prompt">$</span> Building{" "}
              <span className="terminal-highlight">{text}<span className="terminal-cursor">_</span></span>{" "}
              infrastructure for the future of Web3.
            </p>
            
            <p className="terminal-line">
              <span className="terminal-prompt">$</span> Explore the{" "}
              <a href="https://supernovanetwork.xyz/docs" className="terminal-link" target="_blank" rel="noopener noreferrer">
                documentation
              </a>{" "}
              or contribute on{" "}
              <a href="https://github.com/Carbon-Twelve-C12/supernova" className="terminal-link" target="_blank" rel="noopener noreferrer">
                GitHub
              </a>
              .
            </p>
            
            <p className="terminal-line">
              <span className="terminal-prompt">$</span> Read our <Link to="/blog" className="terminal-link">blog</Link> for updates.
            </p>
            
            <p className="terminal-line">
              <span className="terminal-prompt">$</span> Contact:{" "}
              <a href="mailto:info@c12.space" className="terminal-link">info@c12.space</a>
            </p>
            
            <div className="terminal-input">
              <Link to="/">
                <button className="terminal-button">[HOME]</button>
              </Link>
            </div>
          </div>
        </div>
      </header>
      <div className="footer">Carbon Twelve GmbH 2025 &copy;</div>
    </div>
  );
}

export default App;

